import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import { TitleDivider } from '../../../components/titleDivider';
import { PropertyFormStore } from '../../../stores/properties/propertyFormStore';
import { QuoteTypeStore } from '../../../stores/quoteTypeStore';
import { OneToolCard, OneToolCardBorder } from '../../common/oneToolCard';
import { PropertyInformationAccordion } from '../../propertyInformation/components/propertyInformationAccordion';
import { PreflightPropertyForm } from '../forms/preflightPropertyForm';
import { PreflightActionButtons } from './preflightActionButtons';
import { PropertySupplementalInformationTable } from './propertySupplementalInformationTable';
import { PrefligthCard } from './preflightCard';
import { PreflightStep } from '../../../utils/constants';
import { LoanSubType } from '@roc/feature-utils';
import { RentalPortfolioPreflightPropertyForm } from '../forms/rentalPortfolioPreflightPropertyForm';
import { RentalPortfolioPropertyInformation } from '../../propertyInformation/components/rentalPortfolioPropertyInformationAccordion';

interface PrefligthPropertyCardProps {
  store: QuoteTypeStore;
  propertyFormStore: PropertyFormStore;
  propertyIndex: number;
}

export const PrefligthPropertyCard = observer(
  ({ store, propertyFormStore, propertyIndex }: PrefligthPropertyCardProps) => {
    const step = PreflightStep.PROPERTY;

    const isRentalPortfolio = LoanSubType.RENTAL_PORTFOLIO === store.loanSubtype;

    let bottomContent = null;
    if (!isRentalPortfolio) {
      bottomContent = (
        <>
          <Grid item xs={12}>
            <TitleDivider title="Supplemental Information" />
          </Grid>
          <Grid item xs={12}>
            <PropertySupplementalInformationTable
              store={propertyFormStore}
            />
          </Grid>
        </>);
    }

    const PropertyForm = isRentalPortfolio ? RentalPortfolioPreflightPropertyForm : PreflightPropertyForm;

    return (
      <PrefligthCard
        store={store}
        step={step}
        itemIndex={propertyIndex}
        onEdit={() => store.preflightStore.goToStep(step, propertyIndex)}
        onSave={async () => {
          const isValid = await propertyFormStore.validateProperty(true);
          if (isValid) {
            store.preflightStore.completedProperties.push(propertyFormStore.key);
            store.preflightStore.goToNextStep();
          }
        }}
        FormComponent={() => (
          <PropertyForm
            store={store}
            propertyFormStore={propertyFormStore}
          />
        )}
        AccordionComponent={props => {
          return isRentalPortfolio ?
            (
              <RentalPortfolioPropertyInformation {...props}
                store={propertyFormStore}
                showActions={isRentalPortfolio ? true : !propertyFormStore.isEditing}
                showRemoveButton={false} />
            ) : (
              <PropertyInformationAccordion
                {...props}
                store={propertyFormStore}
                showActions={isRentalPortfolio ? true : !propertyFormStore.isEditing}
                showRemoveButton={false}
                bottom={bottomContent}
              />
            )
        }}
      />
    );
  }
);
